import { Button, Col, Row } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import '../css/patientLandingPage.less';
import ContinueButton from './components/ContinueButton';
import CurrentStep from './components/Steps/CurrentStep';
import StepContainer from './components/Steps/StepContainer';
import useGetLocalStorageData from './hooks/useGetLocalStorageData';
import useStepHandler from './hooks/useStepHandler';
import useJourneyExpiration from '../PatientLandingGeneralComponents/hooks/useJourneyExpiration';
import ByMuvu from '../PatientLandingGeneralComponents/ByMuvu';

const PatientAttentionStatePage = () => {
  const { countryCode } = useParams();
  const getLocalStorageData = useGetLocalStorageData({ countryCode });
  const stepHandler = useStepHandler({ data: getLocalStorageData.userData, countryCode, getExamsOfDay: getLocalStorageData.getExamsOfDay });
  const { t } = useTranslation();
  useJourneyExpiration({ countryCode });

  return (
    <Row className='patient-landing-container mt-30 mb-30' justify="center">
      <Col span={24}>
        <Row justify='center'>
          {
            (getLocalStorageData.goToTabs && getLocalStorageData.surveyExam) ?
              <Col span={24}>
                <Row justify='end' className='pr-20'>
                  <Col xs={22} sm={20} md={16}>
                    <Button className='cmt-button survey-back-button' 
                      loading={stepHandler.loading} 
                      type='primary' 
                      block 
                      onClick={getLocalStorageData.goToSurveyClick}>
                        <div className="text-center survey-option-label">Volver a {getLocalStorageData.surveyExam?.name}</div>
                    </Button>
                  </Col>
                </Row>
              </Col> :
              (
                stepHandler.status !== 'done' &&
                <Col span={24}>
                  <Row justify='center' className='pr-20'>
                    <Col span={16} className="text-center">
                      <h2 className="text-center">
                        {t('patientAttentionStatePage.generalAttentionPage.title')}
                      </h2>
                      <p className="text-center">
                        {t('patientAttentionStatePage.generalAttentionPage.subtitle')}
                      </p>
                    </Col>
                  </Row>
                </Col>
              )
          }
          <Col span={24} xs={22} sm={20} lg={12} md={14} xl={10}>
            <StepContainer
              stepHandler={stepHandler}
            >
              <CurrentStep
                stepHandler={stepHandler}
                goToTabs={getLocalStorageData.goToTabs}
                hasSurvey={getLocalStorageData.hasSurvey}
                isLoading={stepHandler.loading || getLocalStorageData.loading}
                getLocalStorageData={getLocalStorageData}
              />
            </StepContainer>
          </Col>
          {
            !getLocalStorageData.goToTabs &&
            <>
              <Col span={24}>
                <ContinueButton stepHandler={stepHandler} getLocalStorageData={getLocalStorageData} />
              </Col>
              <Col span={24} className='mt-30'>
                <ByMuvu />
              </Col>
            </>
          }
        </Row>
      </Col >
    </Row >
  )
}

export default PatientAttentionStatePage;
